export default "__VITE_ASSET__d79ed93a__"